import { REGISTER_SUCCESS, REGISTER_ERROR, GET_USER, LOGIN_SUCCESS, LOGIN_ERROR, CLOSE_SESSION } from '../actions';
import { AuthState, AuthActions } from '../../@types/authContext';

export default (state: AuthState, action: AuthActions): AuthState => {
    switch (action.type) {
        case REGISTER_SUCCESS:
        case LOGIN_SUCCESS:
            localStorage.setItem('logged', 'true');
            return {
                ...state,
                logged: true,
                message: null,
                loading: false,
            };
        case GET_USER:
            localStorage.setItem('logged', 'true');
            return {
                ...state,
                logged: true,
                user: action.payload,
                loading: false,
            };
        case CLOSE_SESSION:
        case LOGIN_ERROR:
        case REGISTER_ERROR:
            localStorage.removeItem('logged');
            return {
                ...state,
                token: null,
                user: null,
                logged: null,
                message: action.payload,
                loading: false,
            };

        default:
            return state;
    }
};
